<ion-header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-button (click)="goMainPage()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'GIFT_CARD.title' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right ion-padding" *ngIf="credit?.giftCardId">
    <div class="content-div">
      <ion-img class="gift-card-img center" [src]="'./assets/wedding/img/gift-card/' + credit.giftCardId + '.webp'"></ion-img>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" >
  <div class="content-div">
    <div class="ion-text-center ion-margin">
      <ion-text color="dark" [innerHtml]="'GIFT_CARD.msg' | translate ">
      </ion-text>
    </div>
    <ion-card *ngIf="credit?.productId" (click)="presentProductAccountDetailModal(credit.productId)" button>
      <ion-card-header color="tertiary">
        <div class="ion-text-center">
          <ion-img class="product-img center" [src]="'./assets/wedding/img/product/account/' + credit.productId + '.svg'"></ion-img>
          <ion-text class="font-med ion-padding-top" color="dark">
            {{ 'PRODUCT.account.title' | translate }}
          </ion-text>
        </div>
      </ion-card-header>
      <ion-card-content>
        <div class="ion-text-center ion-padding-top">
          <ion-text class="font-14" color="dark" *ngIf="credit.productId">
            {{ 'PRODUCT.account.' + credit.productId + '.desc' | translate }}
          </ion-text>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

<ion-footer *ngIf="credit?.creditId">
  <ion-toolbar>
    <div class="content-div">
      <ion-button expand="block" class="ion-margin" (click)="redeemGiftCard()">
        {{ 'GIFT_CARD.btn.redeem' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>